import { RootState } from "../../../../store";
import { SnackBarMessages } from "./types";

export const selectSnackbarMessages = (state: RootState): SnackBarMessages =>
  state.snackbar.messages;
